import { initializeApp } from "firebase/app";
import { getFirestore, initializeFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyDazVaTsZksVrhIrCnCBNp5wqPGS7Wqjmg",
  authDomain: "little-power.firebaseapp.com",
  projectId: "little-power",
  storageBucket: "little-power.firebasestorage.app",
  messagingSenderId: "696174961781",
  appId: "1:696174961781:web:3b07321dc9aaf4c6c5c43c"

  // apiKey: "AIzaSyAkHDZnJrhHhQJ-vttSInSSXPSWzRAI6Jc",
  // authDomain: "hoorayone-4359f.firebaseapp.com",
  // projectId: "hoorayone-4359f",
  // storageBucket: "hoorayone-4359f.firebasestorage.app",
  // messagingSenderId: "387245089367",
  // appId: "1:387245089367:web:af79af8395c4d3c72ab912"
};

export const app = initializeApp(firebaseConfig);
// export const db = getFirestore();
export const db = initializeFirestore(app, { experimentalForceLongPolling: true })
export const auth = getAuth();
export const storage = getStorage();
export const functions = getFunctions(app);

